module.exports = __webpack_public_path__ + "img/katarina_outside_22.d06f8746.jpg";